import z from "zod";

export const SortTypeSchema = z.enum(["ASC", "DESC", "NONE"]);
export type SortType = z.infer<typeof SortTypeSchema>;

export const SORT_TYPE_LABELS: Record<SortType, string> = {
  ASC: "Ascending",
  DESC: "Descending",
  NONE: "No sorting",
};
